import { ResponseTypes } from "../../services/APIService";

const BASE_URL = process.env.REACT_APP_BASE_URL

export const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

export type APIRequestSaveEarthquakeData = {
    flowId: string;
    minDepth: number;
    maxDepth: number;
    minMagnitude: number;
    maxMagnitude: number;
}

export const APISaveEarthquakeData = async (body: APIRequestSaveEarthquakeData): Promise<{status: boolean, message: string}> => {
    const url = `${BASE_URL}/workflow_engine/api/v1/updateEarthquakeData`
    const header: RequestInit = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${getToken()}`
        },
        body: JSON.stringify(body)
    }

    try
    {
        const response = await fetch(url, header)
        if (response.ok)
        {
            return {status: true, message: 'success'}
        }
        return {status: false, message: 'request failed'}
    }
    catch (error)
    {
        console.error(error)
        return {status: false, message: "failed"}
    }
}

export type APIResponseGetEarthquakeData = {
    flowId: string;
    minDepth: number;
    maxDepth: number;
    minMagnitude: number;
    maxMagnitude: number;
}

export const APIGetEarthquakeData = async (flowId: string): Promise<{status: boolean, data: APIResponseGetEarthquakeData | null, message: string}> => {
    const url = `${BASE_URL}/workflow_engine/api/v1/getEarthquakeData?flowId=${flowId}`
    const header: RequestInit = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${getToken()}`
        }
    }

    try
    {
        const response = await fetch(url, header)

        if (response.ok)
        {
            const responseData = await response.json() as ResponseTypes
            return {status: true, data: responseData.data as APIResponseGetEarthquakeData, message: 'success'}
        }
        return {status: false, data: null, message: 'request failed'}
    }
    catch (error)
    {
        console.error(error)
        return {status: false, data: null, message: "failed"}
    }
}